const SuccessCriteriaReport = require('./success-criteria-report');
const TurnStats = require('./turn-stats');
const SuccessRate  = require('./success-rate');
const TacticDetails = require('./tactic-details');
const stats = require('../../lib/util/math/stats');
const template = require('./tactic-report.tpl').default;

module.exports = DomClass(template, function TacticReport() {
	if (this.header) {
		this.expandLink = '';
		return;
	}

	var _t = this;

	var targetRate = this.targetRate || 85;

	const actualQuantityNeeded = Math.max(
		0, this.quantityNeeded - (this.commander?.tactics?.[this.name] ? 1 : 0)
	);

	this.successRate = actualQuantityNeeded > 0 ? Number(stats.drawSuccess(
		this.quantityNeeded * 1,
		this.population * 1,
		this.turnNeeded * 1 + this.startingHandSize * 1,
		this.matches * 1,
		this.population * 1
	) * 100) : 100;

	var turn;
	var maxTurns = this.population - this.startingHandSize;
	for (turn = 0; turn < maxTurns; turn++) {
		var pct = actualQuantityNeeded ? Number(stats.drawSuccess(
			this.quantityNeeded * 1,
			this.population * 1,
			turn * 1 + this.startingHandSize * 1,
			this.matches,
			this.population * 1
		)) : 100;
		if (pct >= targetRate) {
			break;
		}
	}
	this.actualQuantity = this.quantityNeeded;
	this.actualTurn = turn;

	this.keepLower = '?';
	this.keepUpper = '?';

	['successRate'].forEach(function(prop) {
		_t[prop] = new SuccessRate({
			value: _t[prop],
			decimals: 0
		});
	});

	this.setKeepRange = function(data, targetRate) {
		_t.safeDrawData = data;
		var interval = stats.interval(data, targetRate);
		this.keepLower = interval.lower == null ? ":(" : interval.lower;
		this.keepUpper = interval.upper == null ? ":(" : interval.upper;
	};

	this.expandLink.onclick = function() {
		var details = new TacticDetails({
			name: _t.name,
			safeDrawData: _t.safeDrawData
		});
		details.open();
	};

});
